import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ajouter-sous-meilleurs-biens',
  templateUrl: './ajouter-sous-meilleurs-biens.component.html',
  styleUrls: ['./ajouter-sous-meilleurs-biens.component.scss']
})
export class AjouterSousMeilleursBiensComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
